import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Accordion from 'components/global/Accordion';
import Typography from 'components/global/Typography';

import * as S from './ModuleDetail.styled';

const Ul = ({ children }) => {
	return <ul>{children}</ul>;
};

const Li = ({ children }) => {
	return <li>{children}</li>;
};

const ModuleFaqs = () => {
	const { selectedModule } = useSelector((state) => state.otoPackageList);
	const { t } = useTranslation();

	const faqs = useMemo(() => {
		const faqs = [];
		for (let stepNumber = 1; stepNumber < 20; stepNumber += 1) {
			const question = `${selectedModule?.slug}.faq${stepNumber}.question`;
			const answer = `${selectedModule?.slug}.faq${stepNumber}.answer`;
			if (t(question) !== question && t(answer) !== answer) {
				faqs.push({
					question,
					answer
				});
			} else {
				break;
			}
		}
		return faqs;
	}, [selectedModule]);

	if (faqs.length === 0) {
		return null;
	}

	return (
		<div>
			<S.FAQs>
				<Typography variant="h2" fontWeight="800" noWrap align="center">
					frequentlyAskedQuestions
				</Typography>
				<S.FAQsContent>
					{faqs.map((faq, index) => (
						<Accordion key={index} header={t(faq.question)} defaultVisible={index === 0}>
							<Typography variant="p3" noWrap>
								<Trans
									i18nKey={faq.answer}
									components={{
										ul: <Ul />,
										li: <Li />
									}}
								/>
							</Typography>
						</Accordion>
					))}
				</S.FAQsContent>
			</S.FAQs>
		</div>
	);
};

export default ModuleFaqs;
